// src/tenantAdmin/components/UserStatusPill.jsx
// The member's state in a workspace, as a pill (Brian UI). Modeled on
// RunStatusPill.jsx.
//
// ⛔⛔ THREE states, not two. `is_active: false` has two entirely different
// causes and they need different controls, so they must not read alike:
//   • INVITATO    — !isActive && pendingInvite: the account exists but has never
//                   chosen a credential. It needs a fresh invitation LINK
//                   («Reinvia invito»); activating it answers 409
//                   USER_NEVER_ONBOARDED, because there is no password to restore.
//   • DISATTIVATO — !isActive && !pendingInvite: it had a credential and was
//                   switched off. It needs «Riattiva», which is effective at once.
// Collapsing the two into one "Inattivo" pill is what made the old page offer the
// wrong remedy, so the distinction lives here and in UserRowActions together.
//
// ⚠️ `isActive && pendingInvite` is ATTIVO: the flag says an onboarding link is
// still outstanding, not that the account is unusable — someone the admin
// activated by hand can carry both.
//
// ⚠️ `pendingInvite` is undefined on an older backend payload; that reads as
// falsy, i.e. "Disattivato", which is the pre-existing behaviour.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, RADII, FONT_SANS } from '../../constants/theme.js';

export default function UserStatusPill({ isActive, pendingInvite }) {
  const { t } = useTranslation('admin');
  let cfg;
  if (isActive) {
    cfg = { label: t('manage.status.active'), fg: SEMANTIC.verde.fg, bg: SEMANTIC.verde.bg };
  } else if (pendingInvite) {
    // Info, not error: nothing is wrong — the person simply has not accepted yet.
    cfg = { label: t('manage.status.invited'), fg: SEMANTIC.info.fg, bg: SEMANTIC.info.bg };
  } else {
    cfg = { label: t('manage.status.inactive'), fg: SEMANTIC.errore.fg, bg: SEMANTIC.errore.bg };
  }
  return (
    <span style={{
      display: 'inline-block', padding: '4px 12px', borderRadius: RADII.pill,
      fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap',
      background: cfg.bg, color: cfg.fg, fontFamily: FONT_SANS,
    }}>
      {cfg.label}
    </span>
  );
}
